module.exports = __webpack_public_path__ + "img/card-bg.1598a585.png";